<script>
import IndexComponent from "./IndexComponent.vue";
import InfoComponent from "./InfoComponent.vue";
import PriceComponent from "./PriceComponent.vue";
import ActionComponent from "./ActionComponent.vue";

export default {
  name: "ObjectsComponent",
  components: {
    IndexComponent,
    InfoComponent,
    PriceComponent,
    ActionComponent
  },
  props: {
    objects: {
      type: Array,
      required: true
    },
    reportType: {
      type: Number,
      required: true
    },
    paperReportPrice: {
      type: Number,
      required: true
    },
    deleteCartItemHandler: {
      type: Function,
      required: true
    }
  }
}
</script>

<template>
  <div class="services">
    <div class="table">
      <div class="tr">
        <div class="th num">№</div>
        <div class="th">Услуга</div>
        <div class="th price">Цена</div>
        <div class="th action"></div>
      </div>
      <div v-for="(object, objectIndex) in objects" :key="object.id" class="tr">
        <index-component :index="objectIndex+1" />
        <info-component
          :image-src="object.image"
          :page-alias="object.page.alias"
          :page-name="object.page.name"
          :document-prompt="object.prompt"
        />
        <price-component
          :object-price="object.price"
          :object-price-sale="object.priceSale"
          :report-type="reportType"
          :paper-report-price="paperReportPrice"
        />
        <action-component
          :local-storage-index="object.dbIndex"
          :delete-cart-item-handler="deleteCartItemHandler"
        />
      </div>
    </div>
  </div>
</template>

<style scoped>

.services .table {
  width: 100%;
}

.services .table .td,
.services .table .th {
  padding: 5px;
  vertical-align: middle;
}

.services .table .tr:nth-child(2n) {
  background-color: #f3f3f3;
}

.services .table .num {
  width: 40px;
  text-align: center;
}

.services .table .price {
  width: 100px;
  text-align: center;
}

.services .table .action {
  width: 60px;
  text-align: center;
}

</style>
